import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import "../../../index.css";
import { useEffect, useRef, useState } from "react";
import auxService from "../../../services/AuxService";
import { Condutor, CondutorInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { addCondutor, removeCondutor } from "../../../features/manifestoSlice";
import { getUuidV4, validarCPFCNPJ } from "../../../utils/utils";
import { JConfirmDelete, MakeMessageError, MensagemModal } from "../../../components/Components";

const initialForm = {
    nome: '',
    cpf: ''
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function Condutores() {
    const dispatch = useDispatch();
    const [selectCondutores, setSelectCondutores] = useState<CondutorInterface[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const listaCondutores = useSelector((state: RootState) =>
        state.manifesto.manifesto.modal_rodoviario.tracao.condutores);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const [formCondutor, setFormCondutor] = useState(initialForm)
    const selectedCondutorRef = useRef<HTMLSelectElement>(null);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleAddSelectedCondutor = () => {
        const value = selectedCondutorRef?.current?.value || '0'
        const condutor = selectedCondutorRef.current?.options[selectedCondutorRef.current?.selectedIndex].text || '|';
        let nome = '';
        let cpf = '';

        if (value === '0') {
            alerta('Selecione um condutor!');
            return;
        }

        nome = condutor.split('|')[0].trim();
        cpf = condutor.split('|')[1].trim();

        if (validaPreenchimento(nome, cpf)) {
            dispatch(addCondutor({
                id: getUuidV4(),
                CPF: cpf,
                xNome: nome
            }));
        }
    }

    const handleAddCondutor = () => {

        if (validaPreenchimento(formCondutor.nome, formCondutor.cpf)) {

            dispatch(addCondutor({
                id: getUuidV4(),
                CPF: formCondutor.cpf,
                xNome: formCondutor.nome
            }));

            setFormCondutor(initialForm)
        }
    }

    const validaPreenchimento = (nome: string, cpf: string) => {
        if (nome === '') {
            alerta('Informe o nome do condutor.');
            return false;
        }

        if (nome.length <= 1) {
            alerta('O nome do condutor deve ter pelo menos 2 caracteres.');
            return false;
        }

        if (cpf === '') {
            alerta('Informe o CPF do condutor.');
            return false;
        }

        if (!validarCPFCNPJ(cpf)) {
            alerta('CPF inválido.');
            return false;
        }

        if (listaCondutores.length >= 10) {
            alerta('Número máximo de condutores atingido.');
            return false;
        }

        if (listaCondutores.find((item: any) => item.CPF === cpf)) {
            alerta('Condutor com esse CPF já foi adicionado.');
            return false;
        }

        setMessageAlert('')
        setShowAlert(false)
        return true;
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleRemoveCondutor = (id: number) => {
        dispatch(removeCondutor(id));
        setShowModal(false);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormCondutor((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    useEffect(() => {
        auxService.getCondutores().then((res) => {
            setSelectCondutores(res.data)
        })
        
    }, []);

    return (<>
        <Row className="g-2 mb-4">
            <Col md>
                <Form.Group>
                    <Form.Label>Condutores cadastrados</Form.Label>
                    <Form.Select ref={selectedCondutorRef}>
                        <option value="0">Selecione um condutor</option>
                        {selectCondutores?.map((item) => (
                            <option key={item.id} value={item.id}>{item.name} | {item.cpf}</option>
                        )
                        )}
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Button type="button" onClick={handleAddSelectedCondutor} title="Adicionar um condutor a lista" >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>
        </Row>


        <fieldset className="group-box">
            <legend>Adicionar manualmente</legend>
            <Row className="g-2 mb-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Nome do condutor</Form.Label>
                        <Form.Control name="nome" onChange={handleChange} value={formCondutor.nome}
                            maxLength={60} minLength={2} />
                    </Form.Group>
                </Col>

                <Col md >
                    <Form.Group >
                        <Form.Label>CPF</Form.Label>
                        <Form.Control name="cpf" onChange={handleChange} value={formCondutor.cpf} maxLength={11} />
                    </Form.Group>
                </Col>

                <Col md={'auto'} className="d-flex align-items-end">
                    <Button onClick={handleAddCondutor} title="Adicionar um condutor a lista">
                        <FontAwesomeIcon icon={faPlus} /> Adicionar
                    </Button>
                </Col>

            </Row>
        </fieldset>

        <h6>(10 no máximo)</h6>
        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_condutores" />
        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Nome do condutor</th>
                    <th>CPF</th>
                </tr>
            </thead>
            <tbody>
                {listaCondutores?.map((item: Condutor) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger"
                                onClick={() => handleOpenModal({ id: item.id, title: item.xNome })}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.xNome}</td>
                        <td>{item.CPF}</td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemoveCondutor}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}